import React from 'react'
import { SkeletonCard, SkeletonBox, SkeletonText, SpookySkeleton } from '@offerzen/pinata'
import styles from './styles'

const SkeletonStatusInfoCard = () => (
  <SpookySkeleton>
    <SkeletonCard className={styles.card}>
      <div className={styles.header}>
        <SkeletonBox theme="dark" className={styles.icon} />
        <SkeletonText theme="dark" width="150" />
      </div>

      <SkeletonBox theme="dark" className={styles.content} />
    </SkeletonCard>
  </SpookySkeleton>
)

export default SkeletonStatusInfoCard
